import * as msal from 'msal'

// MSAL object used for signing in users with MS identity platform
let msalApp
const LOGIN_SCOPES = [ 'user.read','calendars.readwrite', 'sites.readwrite.all','openid', 'profile', 'mail.readwrite','files.readwrite.all','sites.manage.all', 'group.readwrite.all','sites.fullcontrol.all', 'sites.readwrite.all' ]


export default {
  //
  // Configure with clientId or empty string/null to set in "demo" mode
  //
  async configure(clientId) {
    if (msalApp) { return }

    const config = {
      auth: {
        clientId: "4e55ad04-61e4-4577-bc0f-d2cf29e4a1b8",
        tenantId: "9fb40495-031a-4daf-ba51-833dfc086ecd", 
        authority: "https://login.microsoftonline.com/9fb40495-031a-4daf-ba51-833dfc086ecd",
        redirectUri: window.location.origin,
        validateAuthority: true,
        
      },
      cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
      },
      // Only uncomment when you *really* need to debug what is going on in MSAL
      /* system: {
        logger: new msal.Logger(
          (logLevel, msg) => { console.log(msg) },
          {
            level: msal.LogLevel.Verbose
          }
        )
      } */
    }
    // console.log('### Azure AD sign-in: enabled\n', config)

    // Create our shared/static MSAL app object
    msalApp = new msal.UserAgentApplication(config)
  },

  //
  // Return the configured client id
  //
  clientId() {
    if (!msalApp) { return null }

    return msalApp.clientId
  },

  //
  // Login a user with a popup
  //
  async login() {
    if (!msalApp) { return }

    await msalApp.loginRedirect({
      scopes: LOGIN_SCOPES,
      prompt: 'select_account'
    }).then(()=>
    location.reload()
    )
  },
  async popupLogin() {
    if (!msalApp) { return }

    await msalApp.loginPopup({
      scopes: LOGIN_SCOPES,
      prompt: 'select_account'
    }).then(()=>
    location.reload()
    )
  },

  //
  // Logout any stored user
  //
  async logout() {
    if (!msalApp) { return }

    await msalApp.logout()
  },

  //
  // Call to get user, probably cached and stored locally by MSAL
  //
  user() {
    if (!msalApp) { return null }

    return msalApp.getAccount()
  },

  //
  // Call through to acquireTokenSilent or acquireTokenPopup
  //
  async acquireToken(scopes = [ 'user.read' ]) {
    if (!msalApp) { return null }

    // Set scopes for token request
    const accessTokenRequest = {
      scopes : LOGIN_SCOPES
    }

    let tokenResp
    try {
      // 1. Try to acquire token silently
      tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest)
      //console.log('### MSAL acquireTokenSilent was successful')
    } catch (err) {
      // 2. Silent process might have failed so try via popup
      tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest)
      //console.log('### MSAL acquireTokenPopup was successful')
    }

    // Just in case check, probably never triggers
    if (!tokenResp.accessToken) {
      throw new Error('### accessToken not found in response, that\'s bad')
    }
    return tokenResp.accessToken
  },

  //
  // Clear any stored/cached user
  //
  clearLocal() {
    if (msalApp) {
      msalApp.cacheStorage.clear()
    }
  }
}